import { render, staticRenderFns } from "./CashRegisterIcon.vue?vue&type=template&id=5735fe4e&"
import script from "./CashRegisterIcon.vue?vue&type=script&lang=ts&"
export * from "./CashRegisterIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports